import { UPDATE_USER_REF, UPDATE_USER_REF_SUCCESS, UPDATE_USER_REF_FAILURE } from "../actionTypes";

export const updateUserRef = (payload) => ({
  type: UPDATE_USER_REF,
  payload,
});

export const updateUserRefSuccess = () => ({
  type: UPDATE_USER_REF_SUCCESS,
});

export const updateUserRefFailure = () => ({
  type: UPDATE_USER_REF_FAILURE,
});
